import React from "react";
import PropTypes from "prop-types";

import Filters from "../../../../components/Filter";

const CompaniesListFilter = ({
  labels,
  shared,
  searchInput,
  onSearchChange,
  statusFilterValue,
  statusOptions,
  onStatusChange,
  createdFrom,
  createdTo,
  onCreatedFromChange,
  onCreatedToChange,
  endDateBeforeStart,
  clearFilters,
}) => (
  <Filters
    searchInput={{
      placeholder: labels.searchPlaceholder,
      name: "companiesSearch",
      value: searchInput,
      onChange: onSearchChange,
    }}
    filters={[
      {
        type: "filter",
        name: "companiesStatus",
        placeholder: labels.statusFilter,
        label: labels.statusFilter,
        wrapperClass: "companies-list-view__filter-field",
        value: statusFilterValue,
        options: statusOptions,
        isMultiple: true,
        onChange: onStatusChange,
      },
      {
        type: "date",
        name: "companiesCreatedFrom",
        placeholder: shared.dateInputFormatPlaceholder,
        label: labels.createdFrom,
        wrapperClass: "companies-list-view__filter-field",
        value: createdFrom,
        onChange: onCreatedFromChange,
        clearfilters: clearFilters,
        disableFuture: true,
      },
      {
        type: "date",
        name: "companiesCreatedTo",
        placeholder: shared.dateInputFormatPlaceholder,
        label: labels.createdTo,
        wrapperClass: "companies-list-view__filter-field",
        value: createdTo,
        onChange: onCreatedToChange,
        clearfilters: clearFilters,
        disableFuture: true,
        isInputHasErr: endDateBeforeStart,
        errMsg: "endDateBeforeStartDate",
      },
    ]}
    classNames={{
      container: "companies-list-view__filters",
      base: "",
      search: "mb-3 mb-md-0",
      filter: "mb-3",
    }}
  />
);

CompaniesListFilter.propTypes = {
  labels: PropTypes.object.isRequired,
  shared: PropTypes.object.isRequired,
  searchInput: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  statusFilterValue: PropTypes.array.isRequired,
  statusOptions: PropTypes.array.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  createdFrom: PropTypes.string,
  createdTo: PropTypes.string,
  onCreatedFromChange: PropTypes.func.isRequired,
  onCreatedToChange: PropTypes.func.isRequired,
  endDateBeforeStart: PropTypes.bool.isRequired,
  clearFilters: PropTypes.bool.isRequired,
};

export default CompaniesListFilter;
